var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"icon-button",class:_vm.buttonClasses},_vm.$listeners),[_c('span',{staticClass:"icon icon-button__icon",class:_vm.iconClasses},[_vm._v(_vm._s(_vm.iconChar))])])}
var staticRenderFns = []

export { render, staticRenderFns }